import { Link } from "react-router-dom";
import DefaultData from "../../CompanyData/DefaultData";

export default function B2CTopHeader() {
  return (
    <div className="baba-topbar" style={{ background: DefaultData.THEMECOLOR1 }}>
      <div className="baba-topbar__inner">
        {/* Social icons */}
        <div className="baba-topbar__social">
          <Link to={DefaultData.FACEBOOKURL}  target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <i className="ri-facebook-fill" />
          </Link>
          <Link to={DefaultData.TWITTERURL}   target="_blank" rel="noopener noreferrer" aria-label="Twitter/X">
            <i className="ri-twitter-x-fill" />
          </Link>
          <Link to={DefaultData.INSTGRAMURL}  target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <i className="ri-instagram-fill" />
          </Link>
          <a href={DefaultData.WHATSAPPURL}   target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
            <i className="ri-whatsapp-fill" />
          </a>
        </div>

        {/* Contact info */}
        <div className="baba-topbar__contact">
          <span>
            <i className="ri-whatsapp-line" />
            {DefaultData.DEFAULTCOMPANYWHATSAPPNUMBER}
          </span>
          <span className="baba-topbar__sep">|</span>
          <span>
            <i className="ri-phone-line" />
            {DefaultData.DEFAULTCOMPANYPHONENUMBER}
          </span>
          <span className="baba-topbar__sep">|</span>
          <span>
            <i className="ri-mail-line" />
            {DefaultData.DEFAULTCOMPANYEMAIL}
          </span>
        </div>
      </div>

      <style>{`
        .baba-topbar {
          font-family: 'Inter', sans-serif;
          font-size: 0.8rem;
          font-weight: 500;
          color: #fff;
          padding: 7px 0;
        }
        .baba-topbar__inner {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 1.5rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 8px;
        }
        .baba-topbar__social {
          display: flex;
          gap: 12px;
        }
        .baba-topbar__social a {
          color: rgba(255,255,255,0.85);
          font-size: 0.95rem;
          transition: color 0.2s, transform 0.2s;
          line-height: 1;
        }
        .baba-topbar__social a:hover {
          color: #fff;
          transform: translateY(-1px);
        }
        .baba-topbar__contact {
          display: flex;
          align-items: center;
          gap: 10px;
          color: rgba(255,255,255,0.92);
          flex-wrap: wrap;
        }
        .baba-topbar__contact span {
          display: flex;
          align-items: center;
          gap: 5px;
        }
        .baba-topbar__contact i { font-size: 0.9rem; }
        .baba-topbar__sep { opacity: 0.4; }
        @media (max-width: 600px) {
          .baba-topbar__contact .baba-topbar__sep,
          .baba-topbar__contact span:nth-child(n+4) { display: none; }
        }
      `}</style>
    </div>
  );
}
